var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartFilled = function SvgHeartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M4.219 5.291c2.47-2 5.7-1.535 7.774.425 2.073-1.96 5.265-2.402 7.77-.429 2.63 2.072 2.947 5.599.92 8.071-.805.982-2.4 2.481-3.963 3.879a173 173 0 0 1-3.914 3.385l-.01.009h-.001c-.077.064-.155.13-.226.18a1 1 0 0 1-.303.151.973.973 0 0 1-.848-.151c-.071-.05-.149-.116-.226-.18l-.01-.01c-.775-.649-2.344-1.978-3.915-3.384-1.563-1.398-3.158-2.897-3.963-3.879-2.031-2.477-1.662-5.98.915-8.067",
    clipRule: "evenodd"
  })));
};
export default SvgHeartFilled;